module.exports = __webpack_public_path__ + "img/british-virgin-islands.ea35ce59.svg";